import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_REPORT = `${BACKEND_BASEURL}api/reports/`;

const getDayReports = async () => {
  const response = await axios.get(API_REPORT + "getDayReports");
  return response.data;
};
const getItemReports = async () => {
  const response = await axios.get(API_REPORT + "getItemReports");
  return response.data;
};

const getInventoryInOutReport = async () => {
  const response = await axios.get(API_REPORT + "getInventoryInOutReport");
  return response.data;
};
const ReportServices = {
  getDayReports,
  getItemReports,
  getInventoryInOutReport,
};
export default ReportServices;
